import React, { memo, useMemo } from 'react';

import { TableCell } from '@mui/material';
import { getCellStyles } from 'app/shared/components/common/TableCell/TableCell';
import PropTypes from 'prop-types';

import { TABLE_CELL_ALIGNMENT } from 'constants/ui';

const defaultObject = {};

const HeadCell = ({
  children,
  align = TABLE_CELL_ALIGNMENT.LEFT,
  dataTestId,
  isLargeContent = false,
  customCellStyles = defaultObject,
}) => {
  const cellStyles = useMemo(
    () => ({ ...getCellStyles(isLargeContent), ...customCellStyles }),
    [customCellStyles, isLargeContent],
  );

  return (
    <TableCell align={align} data-testid={dataTestId} scope="row" sx={cellStyles}>
      {children}
    </TableCell>
  );
};

HeadCell.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf(Object.values(TABLE_CELL_ALIGNMENT)),
  dataTestId: PropTypes.string,
  isLargeContent: PropTypes.bool,
  customCellStyles: PropTypes.object,
};

export default memo(HeadCell);
